import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import TransactionLimitsModal from '#client/components/TransactionLimitsModal';
import useModalContext from '#client/hooks/useModalContext';

export default function ViewAllTransactionLimitButton({ isAll }) {
  const { openModal } = useModalContext();

  const handleClick = () => {
    openModal({
      component: TransactionLimitsModal
    });
  };

  return (
    <Text
      color="blue"
      onClick={handleClick}
      size="md"
      sx={{ cursor: 'pointer' }}
      weight="medium"
    >
      {isAll ? 'View all transaction limits' : 'View transaction limits'}
    </Text>
  );
}

ViewAllTransactionLimitButton.propTypes = {
  isAll: PropTypes.bool
};
